/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const MediaVersion = {
    Original: 'Original',
    Converted: 'Converted',
    Playback: 'Playback',
    Preview: 'Preview',
    Thumbnail: 'Thumbnail'
};
export function MediaVersionFromJSON(json) {
    return MediaVersionFromJSONTyped(json, false);
}
export function MediaVersionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MediaVersionToJSON(value) {
    return value;
}
